/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from 'helpers/store'
import {toast} from 'utils/toastUtils'
import {useParams} from 'react-router-dom'
import RecoveryAccessTokenRequested from './RecoveryAccessTokenRequested'
import ForgottenPasswordRecoveryForm from './ForgottenPasswordRecoveryForm'
import RecoveryAccessForm from './RecoveryAccessForm'
import RecoverySuccess from './RecoverySuccess'
import SellerAction from 'store/seller/SellerAction'

const ForgottenPasswordForm = () => {
    const dispatch = useAppDispatch()
    const { register, handleSubmit } = useForm()
    const { t } = useTranslation()
    const { access_token, app_id, m_clk_id } = useParams()

    const [accessToken, setAccessToken] = useState<boolean>(false)
    const [accessTokenRequested, setAccessTokenRequested] =
        useState<boolean>(false)
    const [accessGranted, setAccessGranted] = useState<boolean>(false)
    const [accessEmailRequested, setAccessEmailRequested] = useState<string>('')

    const onSubmitPasswordForgotten = (data) => {
        const app_url = window.location.hostname + ':' + window.location.port
        dispatch(SellerAction.forgottenPassword(data.email, app_url)).then(
            () => {
                setAccessEmailRequested(data.email)
                setAccessTokenRequested(true)
                toast.success(t('Please check your email for access token'))
            }
        )
    }

    useEffect(() => {
        if (access_token) {
            setAccessToken(true)
        }
    }, [access_token])

    if (accessGranted) {
        return <RecoverySuccess />
    }

    if (accessToken) {
        return (
            <RecoveryAccessForm
                accessEmailRequested={accessEmailRequested}
                setAccessGranted={setAccessGranted}
                params={{ access_token, app_id, m_clk_id }}
            />
        )
    }

    if (accessTokenRequested) {
        return <RecoveryAccessTokenRequested />
    }

    return (
        <ForgottenPasswordRecoveryForm
            register={register}
            onSubmit={handleSubmit(onSubmitPasswordForgotten)}
        />
    )
}

export default ForgottenPasswordForm
